import { cn } from "@/lib/utils";

type StatusIndicatorMode = "default" | "voice_status";

type StatusIndicatorProps = {
	status: "online" | "offline";
	size?: "sm" | "md" | "lg";
	className?: string;
	showLabel?: boolean;
	mode?: StatusIndicatorMode;
	isInVoiceChannel?: boolean;
};

const sizeClasses = {
	sm: "h-2 w-2",
	md: "h-3 w-3",
	lg: "h-4 w-4",
};

const getIndicatorColor = (
	mode: StatusIndicatorMode,
	status: "online" | "offline",
	isInVoiceChannel: boolean
) => {
	if (mode === "voice_status") {
		if (status === "offline") return "bg-red-500";
		if (isInVoiceChannel) return "bg-green-500";
		return "bg-blue-500";
	}
	return status === "online" ? "bg-green-500" : "bg-gray-400";
};

const getLabel = (
	mode: StatusIndicatorMode,
	status: "online" | "offline",
	isInVoiceChannel: boolean
) => {
	if (mode === "voice_status") {
		if (status === "offline") return "Offline";
		if (isInVoiceChannel) return "In voice";
		return "Online";
	}
	return status === "online" ? "Online" : "Offline";
};

export function StatusIndicator({
	status,
	size = "md",
	className,
	showLabel = false,
	mode = "default",
	isInVoiceChannel = false,
}: StatusIndicatorProps) {
	return (
		<div className={cn("flex items-center gap-1.5", className)}>
			<div className="relative flex items-center justify-center">
				<div
					className={cn(
						"rounded-full",
						sizeClasses[size],
						getIndicatorColor(mode, status, isInVoiceChannel)
					)}
				/>
			</div>
			{showLabel && (
				<span className="text-muted-foreground text-xs">
					{getLabel(mode, status, isInVoiceChannel)}
				</span>
			)}
		</div>
	);
}
